import { initAll } from "govuk-frontend";

initAll();
import "@hotwired/turbo-rails"
import "./controllers"
import 'dfe-frontend/dist/dfefrontend.min.js';
